// extracted by mini-css-extract-plugin
module.exports = {"sidebarWidth":"200px","sidebarCollapsedWidth":"60px","navbarHeight":"64px","colorDanger":"#f50","colorSuccess":"#87d068","colorWaring":"#f5222d","fontSize":"14"};